import type {AppIconProps} from "../Icons.types";
import {getClassNames} from "../Icons.utils";
import styles from "./Num04.module.scss";

export const Num04Icon = (props: AppIconProps) => {
  const {className, ...rest} = props;
  const classNames = getClassNames(styles.icon, className);

  return (
    <svg {...rest} className={classNames} xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path fill="#000" d="M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z" opacity="0.6"></path>
      <path fill="#fff" d="M16.592 13.313c-.442.578-.912 1.207-1.411 1.887-.499.68-.918 1.377-1.258 2.091h2.669v-3.978zm2.482-3.094v7.072h1.258v2.074h-1.258V22h-2.482v-2.635h-5.083v-1.853c.25-.499.56-1.06.935-1.683a32.332 32.332 0 012.703-3.893c.51-.635 1.02-1.207 1.53-1.717h2.397z"></path>
    </svg>
  );
};
